import React from 'react'
import { User, BarChart2, Building, ArrowRight } from 'lucide-react'
import { toGO } from '../navBar'

const UserTypes = () => {
  const userTypes = [
    {
      icon: <User className='w-6 h-6 text-blue-600' />,
      title: 'For beginners',
      description:
        'A simple app interface for new traders and investors makes Bitvavo the easiest entry point to the world of digital assets.',
      link: 'Get started',
      href: '#'
    },
    {
      icon: <BarChart2 className='w-6 h-6 text-blue-600' />,
      title: 'For experienced traders',
      description:
        'Bitvavo offers an advanced interface and multiple order types, so you can trade and execute your advanced trading strategies.',
      link: 'View exchange',
      href: '#'
    },
    {
      icon: <Building className='w-6 h-6 text-blue-600' />,
      title: 'For institutions',
      description:
        'Bitvavo is one of the European market leaders and offers tailor-made services for institutional investors and crypto funds.',
      link: 'Enterprise solutions',
      href: '#'
    }
  ]

  return (
    <div className='max-md:px-4'>
      <div className='grid grid-cols-1 md:grid-cols-3 gap-12'>
        {userTypes.map((type, index) => (
          <div key={index} className='space-y-4' onClick={toGO}>
            {/* Icon and Title Row */}
            <div className='flex items-center gap-4 md:block'>
              <div className='w-10 h-10 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center rounded-full bg-blue-50'>
                {type.icon}
              </div>

              <h3 className='text-2xl font-semibold md:mt-4'>{type.title}</h3>
            </div>

            {/* Description */}
            <p className='text-lg text-gray-600 leading-relaxed'>{type.description}</p>

            {/* Link */}
            <a href={type.href} className='inline-flex items-center text-blue-600 hover:text-blue-700 font-medium group'>
              {type.link}
              <ArrowRight className='w-4 h-4 ml-1 transition-transform group-hover:translate-x-1' />
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export default UserTypes
